import { Component, ElementRef, inject, NgZone, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { DatePipe } from '@angular/common';
import { heroPaperAirplane, heroInformationCircle } from '@ng-icons/heroicons/outline';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { EmployeeDto } from '@app/_api/dto';
import { TreeViewDataService } from '@app/core/services/tree-view.data.service';

@Component({
  selector: 'if-skill-certificate-confirmation',
  templateUrl: './skill-certificate-confirmation.component.html',
  imports: [NgIcon, DatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [provideIcons({ heroPaperAirplane, heroInformationCircle })],
})
export class SkillCertificateConfirmationComponent implements OnInit {
  readonly confirmButton = viewChild.required<ElementRef>('confirmButton');
  showDialog = false;
  employee?: EmployeeDto;
  readonly employeeDataService = inject(EmployeeDataService);
  readonly treeViewDataService = inject(TreeViewDataService);

  private readonly ngZone = inject(NgZone);

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('click', this.onDocumentClick.bind(this));
    });
  }

  onDocumentClick(e: MouseEvent) {
    if (!this.confirmButton().nativeElement.contains(e.target) && this.showDialog) {
      this.ngZone.run(() => {
        this.showDialog = false;
      });
    }
  }

  toggleDialog() {
    this.showDialog = !this.showDialog;
  }

  confirm() {
    this.employeeDataService.confirm();
    this.toggleDialog();
  }
}
